"use server";

import { authenticatedBitswanBackendInstance } from "@/lib/api-client";
import { getActiveOrgFromCookies } from "./organisations";

export type TokenData = {
  automation_server_id: string;
  workspace_id: string;
  token: string;
};

type GetMQTTTokensResponse = {
  tokens: TokenData[];
};

export async function getMQTTTokens() {
  const bitswanBEInstance = await authenticatedBitswanBackendInstance();
  const activeOrg = await getActiveOrgFromCookies();

  const res = await bitswanBEInstance.get<GetMQTTTokensResponse>(
    "/user/emqx/jwts",
    {
      headers: {
        "X-Org-Id": activeOrg?.id ?? "",
      },
    },
  );

  return res.data?.tokens ?? [];
}
